import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Briefcase, ArrowLeft } from 'lucide-react';
import toast, { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { employerService } from '../../services/employerService';
import JobForm from '../../components/employer/JobForm';

const PostJob = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Controls the loading spinner on the submit button while the API call is in flight
  const [loading, setLoading] = useState(false);

  // Handles form submission-calls the API then redirects on success
  const handleSubmit = async (jobData) => {
    setLoading(true);

    try {
      const res = await employerService.postJob(jobData);
      console.log('Job Created Successfully:', res.data);
      toast.success(t('postJob.success.posted', 'Job posted successfully!'));

      setTimeout(() => {
        navigate('/employer/jobs');
      }, 1500);
    } catch (error) {
      console.error('Error posting job:', error);
      const msg = error.response?.data?.detail || t('postJob.validation.fixErrors', 'Failed to post job');
      toast.error(typeof msg === 'string' ? msg : JSON.stringify(msg));
    } finally {
      // Always re-enable the button regardless of success or failure
      setLoading(false);
    }
  };

  // Ask for confirmation before leaving-prevents accidental data loss
  const handleCancel = () => {
    if (window.confirm(t('postJob.confirmCancel'))) {
      navigate('/employer/jobs');
    }
  };

  return (
    <>
      {/* Toast notification container-appears top-right */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: { background: '#363636', color: '#fff' },
          success: {
            duration: 3000,
            iconTheme: { primary: '#10b981', secondary: '#fff' },
          },
          error: {
            duration: 4000,
            iconTheme: { primary: '#ef4444', secondary: '#fff' },
          },
        }}
      />

      <div className="max-w-4xl mx-auto">
        {/*Page header*/}
        <div className="mb-8">
          {/* Back button*/}
          <button
            onClick={handleCancel}
            className="flex items-center text-gray-600 hover:text-gray-900 transition-colors mb-4 group"
          >
            <ArrowLeft className="w-5 h-5 mr-2 group-hover:-translate-x-1 transition-transform" />
            {t('postJob.back')}
          </button>

          {/* Page title  */}
          <h1 className="flex items-center text-3xl md:text-4xl font-bold text-gray-900 mb-2">
            <Briefcase className="w-8 h-8 md:w-10 md:h-10 mr-3 md:mr-4 text-blue-600" />
            {t('postJob.title')}
          </h1>

          <p className="text-gray-600 text-sm md:text-base">
            {t('postJob.subtitle')}
          </p>
        </div>

        {/* Job form-handles all field inputs and validation internally */}
        <JobForm
          onSubmit={handleSubmit}
          submitButtonText={t('postJob.postButton')}
          loading={loading}
          onCancel={handleCancel}
        />
      </div>
    </>
  );
};

export default PostJob;